/** Thrown when content does not fit the Klarity block schema. `path` points at the offending part. */
export class SchemaError extends Error {
  readonly path: string;

  constructor(message: string, path = "") {
    super(path ? `${path}: ${message}` : message);
    this.name = "SchemaError";
    this.path = path;
  }
}
